// removed by extract-text-webpack-plugin
module.exports = {"root":"_2PCQZ","inner":"_3ytaR","contentLeft":"_27kYa","contentRight":"_1jbuj","heading":"_22A6b","subheading":"_J2exd","arrowIcon":"_UPx0O","contentRow":"_3n4Bj","text":"_3mH3z","googleIcon":"_2Zq1d","seeMore":"_1AxKG"};


//////////////////
// WEBPACK FOOTER
// ./app/components/CTAFooter/CTAFooter.scss
// module id = 1114
// module chunks = 2